import store from "@/store";
import { VuexModule, getModule, Module, Action } from "vuex-module-decorators";
import { SendActivityApiRequest } from "@/data/payload/api/ActivityApiRequest";
import { container } from "tsyringe";
import { ActivityPresenter } from "../presenters/ActivityPresenter";
import { ActivityComponent } from "@/app/infrastructures/dependencies/modules/ActivityComponent";
ActivityComponent.init();

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "activity"
})
class ActivityStore extends VuexModule {
  @Action
  sendActivity(payload: SendActivityApiRequest) {
    const presenters = container.resolve(ActivityPresenter);
    return presenters.sendActivity(payload);
  }
}

export const ActivityController = getModule(ActivityStore);
